import { Injectable } from '@angular/core';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { StorageService } from './storage/local.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserDetails } from '../components/models/dashboard.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    keyClockUrl = environment.keyCloackApiUrlV2 + environment.KEYCLOCK;
    userDetails$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        private keycloakService: KeycloakService,
        private localService: StorageService,
        private http: HttpClient
    ) { }



    getLoggedinUser () {
        return this.keycloakService.getToken();
    }

    setToken (token: any) {
        const keycloakInstance = this.keycloakService.getKeycloakInstance();
        keycloakInstance.token = token;
    }

    getAccessToken () {
        return this.keycloakService.getKeycloakInstance().idTokenParsed;
    }

    getRoles () {
        this.keycloakService.getUserRoles();
    }

    logout () {
        this.keycloakService.logout();
        localStorage.clear();
        this.localService.clear();
        sessionStorage.clear();
    }

    clearCache () {
        this.localService.clear();
        localStorage.clear();
        sessionStorage.clear();
    }

    getUserPermission (sub: string): Observable<any> {
        const url = `${this.keyClockUrl}realms/${environment.keycloak.realm}/permission/${sub}`;
        return this.http.get(url);
    }

    getCadreDetails (sub: string): Observable<any> {
        // const url = `${environment.baseUrl}api/cadre-profile/v1/cadre-profile/${sub}`;
        const url = `${environment.cadreApiBaseUrl}cadre-profile/${sub}`;
        return this.http.get(url);
    }
      getLinkAccounts() {
        const url = `${environment.fdmApiBaseUrl}api/admin/v1/master/config/bookkeeper/link-account`
        return this.http.get(url, { observe: 'body' });
    }
}
